/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $ from 'jquery';
import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
//
const selectors = {
  list: '.js-hero-slides',
  item: '.hero__slide',
};

/**
 * Testimonials section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

register('hero-index', {
  onLoad() {

    this.$container = $(this.container);
    this.namespace = `.${this.id}`;

    this.$sliders = $(selectors.list, this.$container);
    if (this.$sliders.length > 0) {
      this.flick = new Flickity(this.$sliders[0], {
        pageDots: true,
        adaptiveHeight: true,
        imagesLoaded: true,
        cellSelector: selectors.item,
        wrapAround: true,
        dragThreshold: 15,
        prevNextButtons: false,
      });
    }
  },

	/**
	 * Event callback for Theme Editor `section:unload` event
	 */
  onUnload() {
    if (this.flick) {
      this.flick.destroy();
    }
    this.$container.off(this.namespace);
  },
});
